module.exports = __webpack_public_path__ + "static/img/portfolio1.952bf70.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/portfolio1.jpg
// module id = Q/kB
// module chunks = 0